<template>
  <section
    id="gameHistory"
    class="section sidearm-mm-game-history bg-white"
    data-anchor="featured-games"
  >
    <div class="slide sidearm-mm-overall-history relative">
      <section-background css_var="--section-desktop-bg-how-we-got-here"></section-background>
      <div
        class="sidearm-mm-overall-history__content flex flex-align-stretch h-100 w-100 relative"
      >
        <video-background
          v-if="section.background_type === 'video'"
          :video="section.background_video"
        />
        <div
          class="sidearm-mm-overall-history__body text-white col-3-of-8 col-push-1 flex flex-column flex-justify-center relative"
        >
          <h3 v-if="section.title" class="type-hero mb-4">
            {{ section.title }}
          </h3>

          <p v-if="section.sub_title" class="type-paragraph-large ma-0">
            {{ section.sub_title }}
          </p>
        </div>
        <div
          class="sidearm-mm-overall-history__divider sidearm-mm-overall-history__divider--start flex flex-align-center flex-justify-start col-1-of-8 relative"
        >
          <span></span>
        </div>
        <div
          class="sidearm-mm-overall-history__aside col-3-of-8 flex flex-column flex-align-center flex-justify-center"
        >
          <div
            class="sidearm-mm-overall-history__record-items h-100 flex flex-align-stretch flex-justify-start flex-wrap text-white relative"
          >
            <div
              v-for="stat in overall_stats"
              :key="stat.label"
              class="sidearm-mm-overall-history__record-item flex flex-column flex-align-center flex-justify-center w-50 text-center"
            >
              <div
                class="sidearm-mm-overall-history__record-title type-paragraph-regular pb-1"
              >
                {{ stat.label }}
              </div>
              <div
                v-if="$root.data"
                class="sidearm-mm-overall-history__record-value type-hero-small px-1 text-center"
              >
                {{ $root.data.record[stat.key] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="sidearm-mm-overall-history__divider sidearm-mm-overall-history__divider--end absolute"
      >
        <span></span>
      </div>
      <background-element
        class="sidearm-mm-overall-history__top-background-element  col-1-of-8 absolute"
      />
      <background-element
        class="sidearm-mm-overall-history__bottom-background-element  col-5-of-8 absolute"
      />
    </div>
    <slide-game-recap
      v-for="(game, game_index) in section.games"
      :key="game.id"
      :game="game"
      :index="game_index + 1"
    />
    <div
      class="slide sidearm-mm-game-history__transition"
      data-anchor="featured-games-end"
    >
      <div class="flex flex-align-stretch h-100 w-100">
        <div
          class="col-1-of-8 col-push-4 flex flex-align-center bg-white h-100 relative"
        >
          <div class="sidearm-mm-game-history__transition-divider"></div>
        </div>
        <div class="col-3-of-8 bg-white h-100 relative"></div>
      </div>
    </div>
  </section>
</template>

<script>
import SlideGameRecap from "@/components/Slides/SlideGameRecapDesktop";
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  name: "SectionGameHistoryDesktopContent",
  components: {
    SlideGameRecap,
    BackgroundElement
  },
  data: () => ({
    //games are from admin
    overall_stats: [
      { label: "Overall", key: "overall" },
      { label: "Home", key: "home" },
      { label: "Conf", key: "conference" },
      { label: "Away", key: "away" },
      { label: "Streak", key: "streak" },
      { label: "Neutral", key: "neutral" }
    ]
  }),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.how_we_got_here_section;
    }
  }
};
</script>
<style lang="scss">
.sidearm-mm-game-history {
  .fp-slidesNav {
    @include reset-slides-nav;
    opacity: 1;
    transition: opacity 0.7s;
    pointer-events: none;
    &.fp-bottom {
      bottom: #{grid_percent(120)};
    }
    ul {
      display: flex;
      justify-content: center;
      width: 25%;
      margin-left: 50%;
      li {
        padding-right: 18px;
        position: relative;
        overflow: hidden;
        pointer-events: all;
        &:first-child,
        &:last-child {
          display: none;
        }
        &::after {
          position: absolute;
          top: 50%;
          left: calc(1.5rem);
          width: 100%;
          height: 1px;
          content: "";
          border-top: dashed 1px $color-white;
        }
        a {
          margin-right: 0;
          transition: margin 0.3s;
          &.active {
            margin-right: 48px;
            span {
              border: dashed 1px $color-white;
              width: 100%;
              height: 100%;
            }
          }
          span {
            border: solid 3px $color-white;
            transition: border 0.3s, width 0.3s, height 0.3s;
          }
        }
      }
    }
  }
  .slide {
    transition: transform 0.7s;
  }
  &.on-transition-slide {
    .slide:nth-last-child(2) {
      transform: translateX(calc(62.5%));
      transition: transform 0.7s;
      .sidearm-mm-game-recap__slide-in {
        transform: none;
      }
    }
  }
}

body.fp-viewing-featured-games-0,
body.fp-viewing-featured-games-featured-games-end {
  .sidearm-mm-game-history {
    .fp-slidesNav {
      opacity: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.sidearm-mm-overall-history {
  &__divider {
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      &::before {
        width: calc(100% - 1.5rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        content: "";
        background: $color-white;
      }
      &::after {
        width: 1px;
        height: calc(50% + #{$header-height});
        position: absolute;
        bottom: 50%;
        right: 0;
        content: "";
        background-color: $color-white;
      }
    }
    &--end {
      width: 60px;
      top: calc(50% + #{$header-height/2});
      right: 0;
      transform: translateY(-50%);
      &::before {
        position: absolute;
        top: 50%;
        left: 1.5rem;
        height: 1px;
        width: calc(100% - 1.5rem);
        content: "";
        background: $color-white;
      }
      &::after {
        width: 400px;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 100%;
        content: "";
        background: $color-black;
      }
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 0;
    height: calc(100% - #{$header-height});
    z-index: 1;
  }
  &__content {
    z-index: 2;
    padding-top: #{$header-height};
  }
  &__record-items {
    width: 100%;
    padding: 0 calc(#{grid_percent(60)} + 60px) 0 #{grid_percent(60)};
  }
  &__record-item {
    background: rgba(0, 0, 0, 0.5);
    padding: #{grid_percent(60)};
  }
}
.sidearm-mm-game-history {
  &__transition {
    position: relative;
    z-index: 2;
  }
  &__transition-divider {
    &::before {
      position: absolute;
      top: calc(50% + #{$header-height/2});
      right: 0;
      width: 100%;
      height: 1px;
      content: "";
      background: $color-black;
    }
    &::after {
      height: calc(50% - #{$header-height/2});
      position: absolute;
      width: 1px;
      bottom: 0;
      right: 0;
      content: "";
      background-color: $color-black;
    }
  }
}
</style>
